import { createContext, FC, useContext } from 'react'
import { InterpreterFrom } from 'xstate'
import { type machine } from './machine'

interface ContextValue {
  service: InterpreterFrom<typeof machine>
  isLoading: boolean
  canChangePrivacy: boolean
  canRecur: boolean
}

export const Context = createContext<ContextValue | undefined>(undefined)

interface Props {
  canChangePrivacy: boolean
  canRecur?: boolean
  isLoading?: boolean
  service: InterpreterFrom<typeof machine>
}

export const ReviewsWizardProvider: FC<React.PropsWithChildren<Props>> = ({
  children,
  canChangePrivacy,
  isLoading = false,
  service,
  canRecur = false,
}) => {
  return (
    <Context.Provider
      value={{
        service,
        isLoading,
        canChangePrivacy,
        canRecur,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useReviewsWizard = () => {
  const context = useContext(Context)
  if (context === undefined) {
    throw new Error('useReviewsWizard must be within Provider')
  }

  return context
}
